// @flow
import type { Pagination } from '@justpark/api/src/types';

const initialPaginationState: Pagination = {
  currentPage: null,
  perPage: null,
  total: null,
  totalPages: null
};

export default initialPaginationState;
